import type { BetslipView } from '@nsftx/seven-client-sdk-integrator'
import type {
  BetslipNotificationActivity,
  NotificationPayload
} from '#src/interfaces/ngNotifications'

type BetslipEventNames = Extract<BetslipNotificationActivity, 'CONFIRM_PLACE_BETSLIP_FINISHED'>
const BETSLIP_EVENT_MAP = {
  CONFIRM_PLACE_BETSLIP_FINISHED: 'onConfirmPlaceFinished'
} as const satisfies Record<BetslipEventNames, string>

const isMappedBetslipEvent = (
  state: SlipUpdateNotification['content']['activity']['currentState']
): state is keyof typeof BETSLIP_EVENT_MAP => {
  return state in BETSLIP_EVENT_MAP
}

type BetslipEvents = (typeof BETSLIP_EVENT_MAP)[keyof typeof BETSLIP_EVENT_MAP]
type BetslipEventHandlerMap = Partial<Record<BetslipEvents, (ticket: BetslipView) => void>>
type SlipUpdateNotification = NotificationPayload<'ng::slip-update'>

export { BETSLIP_EVENT_MAP, isMappedBetslipEvent }

export type { BetslipEventHandlerMap, BetslipEventNames, SlipUpdateNotification }
